<template>
  <div class="db-100 quick-v-attr-select">
    <span class="attr-title">
          {{ variationGroup.variationGroupName }}
        </span>
    <div class="attr-prop">
      <div class="attr-select-in" v-show="getSelectedText.length > 0">
        {{ getSelectedText }}
      </div>
      <div class="d-flex-100 attr-hex-box">
        <button
          v-for="variationEntry in getVariationEntriesOfThisGroupFromVariationGroupData"
          :key="variationEntry.variationId"
          class="attr-btn-color d-flex justify-content-center align-items-center"
          v-on:click="navigateToProduct(variationEntry.variationId)"
          :style="getButtonStyle(variationEntry)"
          :title="variationEntry.variationName">
          <span><i :class="defaultValue === variationEntry.variationName ? 'lni lni-checkmark' : 'lni'"></i></span>
        </button>
      </div>
    </div>
  </div>

</template>

<script>
import variationSelectorMixin from './VariationSelectorMixin'

export default {
  name: 'VariationHexSelector',
  mixins: [variationSelectorMixin],
  data () {
    return {
      version: '0.0.2'
    }
  },
  methods: {
    getButtonStyle (variationEntry) {
      let baseStyle = `background: ${variationEntry.variationDisplayValue};`
      if (this.defaultValue === variationEntry.variationName) {
        baseStyle += ` border: 1px solid black;`
      }
      return baseStyle
    }
  }
}
</script>

<style lang="scss" scoped>
.attr-title {
  font-size: clamp(1rem, 2.5vw, 1.125rem);
  font-weight: 800;
}
.attr-hex-box {
  gap: 7px;
  button {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    .lni {
      color: black;
    }
  }
}
</style>
